export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "صفحه ورود",
      guestRequired: true,
    },
  },

  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: "پنل مدیریت",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/dashboard/index.vue"),
  },

  {
    path: "/dashboard/users",
    name: "users-management",
    meta: {
      title: "مدیریت کاربران",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/users/index.vue"),
  },

  {
    path: "/dashboard/sellers",
    name: "sellers-management",
    meta: {
      title: "مدیریت فروشندگان",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/sellers/index.vue"),
  },

  {
    path: "/dashboard/orders",
    name: "orders",
    meta: {
      title: "سفارش‌ها",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/orders/index.vue"),
  },

  {
    path: "/dashboard/orders/:id",
    name: "order-details",
    meta: {
      title: "جزئیات سفارش",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/orders/show.vue"),
  },

  {
    path: "/dashboard/reviews",
    name: "reviews",
    meta: {
      title: "نظرات",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/reviews/index.vue"),
  },

  {
    path: "/dashboard/tickets",
    name: "customer-tickets",
    meta: {
      title: "تیکت مشتریان",
      authRequired: true,
      isAdmin: true,
      ticketKind: "customer",
    },
    component: () => import("../views/tickets/index.vue"),
  },

  {
    path: "/dashboard/tickets/:id",
    name: "customer-ticket-details",
    meta: {
      title: "جزئیات تیکت مشتری",
      authRequired: true,
      isAdmin: true,
      ticketKind: "customer",
    },
    component: () => import("../views/tickets/show.vue"),
  },

  {
    path: "/dashboard/seller-tickets",
    name: "seller-tickets",
    meta: {
      title: "تیکت فروشندگان",
      authRequired: true,
      isAdmin: true,
      ticketKind: "seller",
    },
    component: () => import("../views/tickets/index.vue"),
  },

  {
    path: "/dashboard/seller-tickets/:id",
    name: "seller-ticket-details",
    meta: {
      title: "جزئیات تیکت فروشنده",
      authRequired: true,
      isAdmin: true,
      ticketKind: "seller",
    },
    component: () => import("../views/tickets/show.vue"),
  },

  {
    path: "/dashboard/settlements",
    name: "settlements",
    meta: {
      title: "درخواست‌های تسویه",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/settlements/index.vue"),
  },

  {
    path: "/dashboard/settings",
    name: "settings",
    meta: {
      title: "تنظیمات",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/settings/index.vue"),
  },
]